import { render, staticRenderFns } from "./MiraLandingFiguresDialog.vue?vue&type=template&id=632b8044&scoped=true&"
import script from "./MiraLandingFiguresDialog.vue?vue&type=script&lang=ts&"
export * from "./MiraLandingFiguresDialog.vue?vue&type=script&lang=ts&"
import style0 from "./MiraLandingFiguresDialog.vue?vue&type=style&index=0&id=632b8044&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632b8044",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemActionText } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VList,VListItem,VListItemActionText,VListItemAvatar,VListItemContent,VListItemTitle})
